import * as API from "../url";
import { accountsInstance } from "../axiosInstance";

const getRequest = async (url, params = {}) => {
  const res = await accountsInstance.get(url, { params });
  return res.data;
};

const postRequest = async (url, body) => {
  const res = await accountsInstance.post(url, body);
  return res.data;
};

export const getUser = (userId) =>
  getRequest(`${API.GET_USER}?userId=${userId}`);

export const getCountries = () => getRequest(API.GET_COUNTRIES);

export const getStaffs = (pageSize, pageNumber, status, searchParam) =>
  getRequest(
    `${API.GET_ALL_STAFFS}?pageSize=${pageSize}&pageNumber=${pageNumber}${status ? `&status=${status}` : ""}${searchParam && typeof searchParam === "string" ? `&searchParam=${searchParam}` : ""}`,
  );

export const getStaff = (userId) => getRequest(API.GET_STAFF(userId));

export const loggedInUser = () => getRequest(`${API.LOGGED_IN_USER}`);

export const addStaff = (body) => postRequest(API.ADD_STAFF, body);

export const deleteStaff = async (query) => {
  const response = await accountsInstance.delete(API.DELETE_STAFF(query));
  return response.data;
};

export const editStaff = async ({ query, body }) => {
  const response = await accountsInstance.put(API.EDIT_STAFF(query), body);
  return response.data;
};

export const deactivateStaff = async (query) => {
  const response = await accountsInstance.put(API.DEACTIVATE_STAFF(query));
  return response.data;
};

export const reactivateStaff = async (query) => {
  const response = await accountsInstance.put(API.REACTIVATE_STAFF(query));
  return response.data;
};

export const resendInvite = async (body) => {
  const response = await accountsInstance.post(API.RESEND_INVITE, body);
  return response.data;
};
